import { render, staticRenderFns } from "./ClientSummaryInfo.vue?vue&type=template&id=64cdd688&scoped=true&"
import script from "./ClientSummaryInfo.vue?vue&type=script&lang=js&"
export * from "./ClientSummaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientSummaryInfo.vue?vue&type=style&index=0&id=64cdd688&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cdd688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
